import { useIntl } from 'react-intl'
import { styled } from 'styled-components'

import type {
  OrchestratedOfferingListingDetails,
  OrchestratedAuctionListingDetails,
} from '@b-stock/fe-core/bstock-next/queries'
import { Breakpoints, Colors, Typography } from '@b-stock/fe-core/design-system'

import { Card } from '@/buyer-portal/components/layouts/CardLayout/card/ui'

import { ListingKeyAttributes } from './ListingKeyAttributes'
import { SellerTagsRow } from './SellerTagsRow'

const Body = styled(Card)`
  background: ${Colors.Semantic.Neutral.white};
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 0.875rem;
  width: 100%;

  @media ${Breakpoints.max.small} {
    gap: 0.5rem;
  }
`

const Title = styled.h1`
  ${Typography.Title2}
  align-self: stretch;
  color: ${Colors.Semantic.Neutral.black};
  margin: 0;

  @media ${Breakpoints.max.small} {
    ${Typography.Subtitle1}
  }
`

const Text = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const TitleCard = ({
  listing,
}: {
  listing:
    | OrchestratedOfferingListingDetails
    | OrchestratedAuctionListingDetails
}) => {
  const { formatMessage } = useIntl()
  const title = listing.lot.title || formatMessage({ id: 'Common.unknown' })

  return (
    <Body>
      <SellerTagsRow listing={listing} />
      <Text>
        <Title data-testid="lot.title">{title}</Title>
        <ListingKeyAttributes listing={listing} />
      </Text>
    </Body>
  )
}
